import { render, staticRenderFns } from "./handleDataDownload.vue?vue&type=template&id=329a7b10&scoped=true"
import script from "./handleDataDownload.vue?vue&type=script&lang=js"
export * from "./handleDataDownload.vue?vue&type=script&lang=js"
import style0 from "./handleDataDownload.vue?vue&type=style&index=0&id=329a7b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a7b10",
  null
  
)

export default component.exports